import { Table, PageHeader, Input } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { createComponentStore, useStoreState } from "easy-peasy";

import {
  UserEventStoreModel,
  ACTION_TYPES,
} from "store/models/reports/user-events";
import { formatDate, isScreenMobile, sort } from "Utils";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import FourOThree from "Pages/private/403";
import Highlighter from "react-highlight-words";

const { Search } = Input;
const useUserEventsStore = createComponentStore(UserEventStoreModel);

export default function UserEventReportPage() {
  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.READ,
    "Kullanıcı Etkinlikleri"
  );

  const [store, actions] = useUserEventsStore();
  const [filteredValue, setFilteredValue] = useState({});
  const [data, setData] = useState([]);
  const { process } = store;

  useEffect(() => {
    if (IsAuthorized) actions.fetch();
  }, [IsAuthorized]);

  useEffect(() => {
    setData(store.data.sort((a, b) => sort(b.createdAt, a.createdAt)));
  }, [store.data]);

  useEffect(() => {
    if (
      filteredValue.fastSearchParam &&
      filteredValue.fastSearchParam.length > 0
    ) {
      let value = filteredValue.fastSearchParam.toLocaleUpperCase();
      let data = [...store.data].filter((f) => {
        return (
          ((f.user.name || "") + " " + (f.user.surname || ""))
            .toLocaleUpperCase()
            .indexOf(value) !== -1 ||
          f.eventText.toLocaleUpperCase().indexOf(value) !== -1
        );
      });

      setData(data);
    } else {
      setData(store.data);
    }
  }, [filteredValue]);

  const columns = [
    {
      title: "Kullanıcı",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.user.name + " " + record.user.surname}
        />
      ),
      sorter: (a, b) =>
        sort(
          a.user.name + " " + b.user.surname,
          a.user.name + " " + b.user.surname
        ),
    },
    {
      title: "Olay ",
      dataIndex: "eventText",
      sorter: (a, b) => sort(a.eventText, b.eventText),
      key: "eventText",
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={text}
        />
      ),
    },

    {
      title: "Oluşma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => sort(a.createdAt, b.createdAt),
      defaultSortOrder: "descend",
      render: (text, record) => {
        return formatDate(record.createdAt);
      },
    },
  ];

  return IsAuthorized ? (
    <>
      <PageHeader
        title="Kullanıcı Etkinlikleri"
        extra={[
          <Search
            disabled={!IsAuthorized}
            key="search"
            style={isScreenMobile() ? {} : { width: "auto" }}
            placeholder="Ara"
            allowClear={true}
            onSearch={(value) => {
              if (value.length > 0) {
                setFilteredValue({ ...filteredValue, fastSearchParam: value });
              } else {
                if ("fastSearchParam" in filteredValue)
                  delete filteredValue.fastSearchParam;

                setFilteredValue({ ...filteredValue });
              }
            }}
          />,
        ]}
      />
      <Table
        style={{ margin: "0 24px" }}
        rowKey={(row) => row.id}
        loading={process === ACTION_TYPES.FETCHING_DATA}
        dataSource={data}
        columns={columns}
        size="small"
        pagination={{
          pageSize: 20,
          total: data.length,
          showSizeChanger: false,
          showTotal: (total, range) => {
            return `Toplam ${total} sonuçtan ${range.join(
              "-"
            )} arası gösteriliyor.`;
          },
        }}
        bordered
        showSorterTooltip={false}
        scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
      />
    </>
  ) : (
    <FourOThree />
  );
}
